import { Box, Grid, Paper } from "@mui/material";
import React from "react";
import TextSimple from "../../typography/text-simple/TextSimple";
import { styled } from "@mui/system";
import { I_GENERIC_ITEMS } from "../../../model/interface/items.interface";
import { IconFlagFilled } from "@tabler/icons-react";
interface I_OwnerValidate {
  data: DATA;
  emitPayloadExist: (payload: I_GENERIC_ITEMS) => void;
  modalToggle?: () => void;
}
function CardsOwnerSimple(props: I_OwnerValidate) {
  const { data = [] } = props;
  const OnClick = (data: any) => {
    props.emitPayloadExist({
      label: data.name,
      value: data.id,
      ...data
    });
    if (props.modalToggle) props.modalToggle();
  };
  if (data.length === 0) return <></>;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} my={2}>
        <TextSimple size="sub-title" color="blue-02" weight="700">
          {data.length > 1 ? (
            <>
              Se han encontrado propietarios con la misma identificación.
              Por favor, seleccione uno de ellos.
            </>
          ) : (
            <>
              Se ha encontrado un propietario con la misma identificación.
              Si este es el propietario que intentaba registrar, por favor
              haga clic sobre él para continuar.
            </>
          )}
        </TextSimple>
      </Grid>
      {data.map((item, index: number) => (
        <Grid item xs={12} sm={6} md={6}>
          <Item onClick={() => OnClick(item)}>
            <Grid item xs={"auto"} mx={"auto"} gap={1}>
              <TextSimple
                size="label"
                color="blue-02"
                weight="700"
                sx={{ marginRight: "4px" }}
              >
                {item.name} (#{item.id})
              </TextSimple>
              {item.is_conflictive === 1 && (
                <IconFlagFilled
                  style={{
                    fill: "#dc1d2d",
                    fontSize: "8px",
                    width: "14px",
                    height: "14px"
                  }}
                />
              )}
            </Grid>
            <Grid container item xs={12} spacing={1}>
              <Grid item xs="auto">
                <TextSimple size="label" color="gray" weight="700">
                  Correo:
                </TextSimple>
              </Grid>
              <EmailCont item xs={6}>
                <TextSimple size="label" color="gray">
                  {item.email}
                </TextSimple>
              </EmailCont>
            </Grid>
            <Grid container item xs={12} spacing={1}>
              <Grid item xs="auto">
                <TextSimple size="label" color="gray" weight="700">
                  Teléfono:
                </TextSimple>
              </Grid>
              <Grid item xs={6}>
                <TextSimple size="label" color="gray">
                  {item.phone}
                </TextSimple>
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={1}>
              <Grid item xs="auto">
                <TextSimple size="label" color="gray" weight="700">
                  Identificación:
                </TextSimple>
              </Grid>
              <Grid item xs={6}>
                <TextSimple size="label" color="gray">
                  {item.identification}
                </TextSimple>
              </Grid>
            </Grid>
          </Item>
        </Grid>
      ))}
    </Grid>
  );
}

export default CardsOwnerSimple;

const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",

  width: "100%",
  // lg
  [theme.breakpoints.up("lg")]: {}
}));

const Item = styled(Paper)(({ theme }) => ({
  borderRadius: 5,
  border: "1px solid #ccc",
  padding: "1rem",
  cursor: "pointer",
  "&:hover": {
    border: "1px solid #1A3668"
  }
}));

export type DATA = Owners[];

export interface Owners {
  id: number;
  name: string;
  identification: string;
  company_name: string;
  company_identification: string;
  company_identification2: any;
  is_conflictive?: number;

  phone: string;
  phone2: string;
  mobile: string;
  fax: string;
  email: string;
  birthdate: any;
  company_phone: any;
  company_fax: any;
  company_email: any;
  company_position: any;
  country: any;
  city: any;
  sector: any;
  address: string;
  reference: string;
  account_id: number;
  agency_id?: number;
}

const EmailCont = styled(Grid)(({ theme }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));
